import React from 'react';

import {Dimensions, Platform} from 'react-native';
import {BannerAd} from 'react-native-google-mobile-ads';
import { RFValue } from 'react-native-responsive-fontsize';

const iosUnitID = 'ca-app-pub-1056898970671844/9336293998';
const androidUnitID = 'ca-app-pub-1056898970671844/9792972456';

const adUnitId = Platform.OS === 'ios' ? iosUnitID : androidUnitID;

const adHeight = Math.round(RFValue(40));
const adWidth = Math.round(Dimensions.get('screen').width);
const adSize = `${adWidth}x${adHeight}`;

const requestOptions = {
  requestNonPersonalizedAdsOnly: true,
};

function AdsComponent() {
  return (
    <BannerAd
      unitId={adUnitId}
      size={adSize}
      requestOptions={requestOptions}
    />
  );
}

export const Ads = React.memo(AdsComponent);
